import { filterDeep } from 'deepdash-es/standalone';
import { useGetDocumentVariants } from 'pages/documents_v2/hooks/useGetDocumentVariants';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

/**
 * @param {number} [id]
 * @param {boolean} [enabledOnly]
 * @returns {import('../../../models/documents.models').DocumentVariant | undefined}
 */
export function useGetBaseVariant(id = undefined, enabledOnly = false) {
    const { documentId } = useParams();
    const idAsNumber = id ?? parseInt(documentId);
    const variants = useGetDocumentVariants(idAsNumber);

    return useMemo(() => {
        const baseVariant = variants.find((variant) => variant.parentId === null);

        if (baseVariant && enabledOnly) {
            return filterDeep(baseVariant, (value) => value.enabled, {
                childrenPath: 'children',
            });
        }

        return baseVariant;
    }, [variants, enabledOnly]);
}
